import { render, staticRenderFns } from "./InformationMeasureResults.vue?vue&type=template&id=2b86decc&"
import script from "./InformationMeasureResults.vue?vue&type=script&lang=js&"
export * from "./InformationMeasureResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports